import UltMeta, { Meta } from "@/meta/UltMeta/index";

/**
 * 品类规格
 */
class Spec extends UltMeta {
    COARSE = new Meta(1, "粗砂");
    RAW = new Meta(2, "中砂");
    FINE = new Meta(3, "细砂");
    EXTRA_FINE = new Meta(4, "特细砂");
}
export const SPEC = new Spec();
/**
 * 品类指数定义
 */
class productTypeIndex extends UltMeta {
    UP_BOAT = new Meta(1, "上船价");
    TOUCH_PORT = new Meta(2, "靠港价");
}
export const PRODUCT_TYPE_INDEX = new productTypeIndex();

/**
 * 品类指数定义
 */
class productTypeIndexSmall extends UltMeta {
    TOUCH_PORT = new Meta(2, "靠港价");
}
export const PRODUCT_TYPE_INDEX_SMALL = new productTypeIndexSmall();

/**
 * 品类指数定义
 */
class market extends UltMeta {
    JIANG_YIN = new Meta(1, "江阴");
    // WU_HU = new Meta(2, "芜湖");
}
export const MARKET = new market();

class marketIndex extends UltMeta {
    JIANG_YIN = new Meta(1, "江阴");
    WU_HU = new Meta(2, "芜湖");
}
export const MARKET_INDEX = new marketIndex();

/**
 * 品类类型定义
 */
class productTypeState extends UltMeta {
    NATURAL_SAND = new Meta(1, "天然砂");
    MACHINE_MADE_SAND = new Meta(2, "机制砂");
    MACADAM = new Meta(3, "碎石");
}
export const PRODUCT_TYPE_STATE = new productTypeState();

/**
 * 品类区域定义
 */
class productRegionState extends UltMeta {
    BEIJING = new Meta(11, "北京市");
    TIANJIN = new Meta(12, "天津市");
    HEBEI = new Meta(13, "河北省");
    SHANXI = new Meta(14, "山西省");
    NEIMENGGU = new Meta(15, "内蒙古自治区");
    LIAONING = new Meta(21, "辽宁省");
    JILIN = new Meta(22, "吉林省");
    HEILONGJIANG = new Meta(23, "黑龙江省");
    SHANGHAI = new Meta(31, "上海市");
    JIANGSU = new Meta(32, "江苏省");
    ZHEJIANG_REGION = new Meta(6, "浙江省");
    ANHUI_REGION = new Meta(5, "安徽省");
    FUJIAN = new Meta(35, "福建省");
    JIANGXI_REGION = new Meta(4, "江西省");
    SHANDONG = new Meta(37, "山东省");
    HENAN = new Meta(41, "河南省");
    HUBEI_REGION = new Meta(2, "湖北省");
    HUNAN_REGION = new Meta(3, "湖南省");
    GUANGDONG = new Meta(44, "广东省");
    GUANGXI = new Meta(45, "广西壮族自治区");
    HAINAN = new Meta(46, "海南省");
    CHONGQING_REGION = new Meta(1, "重庆市");
    SICHUAN = new Meta(51, "四川省");
    GUIZHOU = new Meta(52, "贵州省");
    YUNNAN = new Meta(53, "云南省");
    XIZANG = new Meta(54, "西藏自治区");
    SHAANXI = new Meta(61, "陕西省");
    GANSU = new Meta(62, "甘肃省");
    QINGHAI = new Meta(63, "青海省");
    NINGXIA = new Meta(64, "宁夏回族自治区");
    XINJIANG = new Meta(65, "新疆维吾尔自治区");
    TAIWAN = new Meta(71, "台湾省");
    HONGKONG = new Meta(81, "香港特别行政区");
    MACAO = new Meta(82, "澳门特别行政区");
}

export const PRODUCT_REGION_STATE = new productRegionState();
